"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var styles = require("./WirelessCart.scss");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var CartActions_1 = require("../../../models/requests/CartActions");
var icons = require("../../../styles/ccc-icons-cart.scss");
var CartUtil = require("../../../utils/CartUtilFunctions");
var CommonUtils = require("../../../utils/CommonUtilFuntions");
var Utils = require("../../../utils/UtilityFunctions");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var TextTooltip_1 = require("../shared/TextTooltip");
var PostpaidAccessoryModal_1 = require("./PostpaidAccessoryModal/PostpaidAccessoryModal");
var EditAndRemove_1 = require("../../CommonCart/common/EditAndRemove");
var expUpStyle = require("../ExpressView/ExpressView.scss");
var components_1 = require("@idp/duc/components");
var textTooptipStyles = require("../shared/TextTooltip/TextTooltip.scss");
var wirelessRTI = require("./WirelessRTI");
var WirelessTradeIn_1 = require("./WirelessTradeIn/WirelessTradeIn");
var AddALine_1 = require("../../panels/AddALine");
var AutoBillPay_1 = require("./AutoBillPay/AutoBillPay");
var WirelessInsurance_1 = require("./WirelessInsurance/WirelessInsurance");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var lodash_1 = require("lodash");
var WirelessHelper = /** @class */ (function (_super) {
    __extends(WirelessHelper, _super);
    function WirelessHelper(props) {
        var _this = _super.call(this, props) || this;
        _this.hideEditAndRemoveLink = false;
        _this.prepaidremoveItemsLinkLabel = 'Remove AT&T PREPAID';
        _this.appSharedOfferModalOpened = false;
        _this.tradeinGotoBuyFlow = false;
        _this.removeTradein = false;
        _this.offerModalLegalObj = {};
        _this.tradeInPortInConsented = { hylatradeInCustomerConsented: false, portInCustomerConsented: false };
        _this.newWireless = false;
        _this.isCommonCart = false;
        _this.savingsPromoFlags = {};
        _this.rewardInfo = {};
        _this.isMixAndMatch = false;
        _this.externalOrderSourceType = '';
        _this.isDownPaymentSeePricingDetails = false;
        _this.billCodesArry = new Array();
        _this.spoDataAvailSkus = [];
        _this.isMixedCart = Utils.getCurrentFlowType() === 'UP_AL_WIRELESS' ? true : false;
        _this.isUnauthAccess = Utils.unauthenticatedAccess();
        _this.commonCartEditUrl = '/buy/wireless/byod';
        _this.checkCapacityEnabledDevices = function (lineItem) {
            var _a, _b;
            var capacitycheckWatch = false;
            if ((_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _a === void 0 ? void 0 : _a.wirelessHardGoodCharacteristics) === null || _b === void 0 ? void 0 : _b.phoneType) {
                var phoneType = lineItem.hardGood.wirelessHardGoodCharacteristics.phoneType.toUpperCase();
                if (_this.isCommonCart && lineItem.hardGood.displaySize) {
                    lineItem.capacity = lineItem.hardGood.displaySize;
                    lineItem.color = lineItem.hardGood.displayColor || '';
                }
                capacitycheckWatch =
                    WirelessHelper.DISPLAY_CAPACITY_EDIT_OPTION_INCLUDES_WATCH.indexOf(phoneType) > -1;
                return !!(capacitycheckWatch && lineItem.capacity);
            }
            else {
                return false;
            }
        };
        _this.openBOGOSeeOfferModal = function () {
            _this.reportingService.fireLinkClickWithOutPageLoad('See offer details', ReportingService_1.PageUrls.CART_BOGO_SEE_OFFER_DETAILS_MODAL);
            _this.setState({ bogoSeeOfferModalDisplayed: true });
        };
        _this.closeBOGOSeeOfferModal = function () {
            _this.reportingService.firePageLoadEvent(CartUtil.getLinkClickBasekUrl());
            _this.setState({ bogoSeeOfferModalDisplayed: false });
        };
        _this.showAttFeesDetail = function () {
            _this.setState({ isModalOpen: true });
            _this.reportingService.
                fireLinkClickThenPageloadEvent('See details', ReportingService_1.PageUrls.CART_SEE_DETAILS_TAXES_FEES_MODAL);
        };
        _this.closeAttFeesDetail = function () {
            _this.reportingService.fireLinkClickEvent(ReportingService_1.CheckoutLinkNames.MODAL_CLOSE, ReportingService_1.PageUrls.CART_SEE_DETAILS_TAXES_FEES_MODAL);
            _this.reportingService.firePageLoadEvent(CartUtil.getLinkClickBasekUrl());
            _this.setState({ isModalOpen: false });
        };
        _this.closeAccessFeeHelpModal = function () {
            _this.reportingService.fireLinkClickEvent(ReportingService_1.CheckoutLinkNames.MODAL_CLOSE, ReportingService_1.PageUrls.CART_ACCESS_FEE_HELP);
            _this.reportingService.firePageLoadEvent(CartUtil.getLinkClickBasekUrl());
            _this.setState({ accessFeeHelpModalDisplay: false });
        };
        _this.getEstDeliveryDates = function () {
            if (_this.billCodesArry.length > 0 && _this.isExpressUp()) {
                _this.api.getDeliveryDates(_this.billCodesArry).then(function (response) {
                    _this.billCodeRespObj = response;
                    _this.setState({ showEstDeliveryDate: true });
                }).catch(function (error) { _this.setState({ showEstDeliveryDate: false }); });
            }
        };
        _this.onChangeUpdateBillCodes = function (billCodes) {
            _this.billCodeRespObj = billCodes;
        };
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.reportingService = new ReportingService_1.default();
        _this.cartSummaryCMSData = wlsUtils.getWlsCmsData();
        _this.showPlanInfoAtLine = _this.showPlanInfoAtLine.bind(_this);
        _this.changeAccessoryQuantity = _this.changeAccessoryQuantity.bind(_this);
        _this.accessoryModal = _this.accessoryModal.bind(_this);
        _this.incompleteCartMessage = _this.incompleteCartMessage.bind(_this);
        _this.showSavingRewardModal = _this.showSavingRewardModal.bind(_this);
        _this.expUpShowHideLink = _this.expUpShowHideLink.bind(_this);
        _this.expUpSeeDetails = _this.expUpSeeDetails.bind(_this);
        _this.showRetailPrice = _this.showRetailPrice.bind(_this);
        _this.isExpressUp = _this.isExpressUp.bind(_this);
        _this.closeMonthlySavingModal = _this.closeMonthlySavingModal.bind(_this);
        _this.installmentMessage = _this.installmentMessage.bind(_this);
        _this.getDownPaymentSeeDetails = _this.getDownPaymentSeeDetails.bind(_this);
        _this.filterLosgs = _this.filterLosgs.bind(_this);
        _this.lobHideEditAndRemoveLink = _this.lobHideEditAndRemoveLink.bind(_this);
        _this.dueMonthlyCrpLaterMessage = _this.dueMonthlyCrpLaterMessage.bind(_this);
        _this.getTradeinPromotion = _this.getTradeinPromotion.bind(_this);
        _this.getHylaDiscountDetails = _this.getHylaDiscountDetails.bind(_this);
        _this.getCRPMessageEligibility = _this.getCRPMessageEligibility.bind(_this);
        _this.getInsuranceData = _this.getInsuranceData.bind(_this);
        return _this;
    }
    WirelessHelper.prototype.editLineForPscCustomers = function (editUrl) {
        if (Utils.isLoginRequiredonCart()) {
            editUrl = Utils.getauthenticatedPersistantLoginURL(true);
        }
        this.props.events.onEdit('WIRELESS', editUrl, 'Edit Line');
    };
    WirelessHelper.prototype.onRemoveClick = function () {
        var _this = this;
        var editLink = this.isCommonCart ? this.commonCartEditUrl : Utils.getEditLinkUrl(this.cartMetaData.editUrl);
        this.stateManager.set('editLinkUrl', { url: editLink });
        var isBundleCart = Utils.isBundleinCart().isBundle;
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', this.identifyPreapidCart() ? this.prepaidremoveItemsLinkLabel :
            this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
            ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.props.events.doLoading(true);
        this.api.emptyAnyLOBCart('WIRELESS').then(function () {
            _this.props.events.doLoading(false);
            sessionStorage.removeItem('byodCombinedResponse');
            sessionStorage.removeItem('byodResponses');
            _this.reportingService.reportSystemEventForSelectedAction(false, '0', _this.identifyPreapidCart() ? _this.prepaidremoveItemsLinkLabel :
                _this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
                ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
            Utils.onCartRemoveLob(true);
        }).catch(function (err) {
            _this.props.events.doLoading(false);
            _this.toggleRemoveModal();
            _this.reportingService.reportSystemEventForSelectedAction(true, undefined, _this.identifyPreapidCart() ? _this.prepaidremoveItemsLinkLabel :
                _this.cartSummaryCMSData.removeItemsLinkLabel, isBundleCart ?
                ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'Error in remvoing cart: ' + JSON.stringify(err));
        });
    };
    WirelessHelper.prototype.toggleRemoveModal = function (onlyPageLoadOnRemove) {
        var _this = this;
        this.setState({ isRemoveModalOpen: !this.state.isRemoveModalOpen }, function () {
            if (onlyPageLoadOnRemove) {
                _this.onRemoveClick();
            }
            else if (_this.state.isRemoveModalOpen) {
                _this.reportingService.fireLinkClickWithOutPageLoad(_this.cartSummaryCMSData.removeItemsLinkLabel, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    WirelessHelper.prototype.showEditAndRemove = function (losg, qualifierPlanName, losgsCount, index, expuplineItem, isAccessory, accessoryLineItem) {
        var _this = this;
        var _a, _b;
        var editUrl = wlsUtils.getEditUrl(this.cartData, this.cartMetaData, losg);
        var removeInfo;
        var lineItems;
        if (this.isUnauthAccess) {
            return (React.createElement(React.Fragment, null));
        }
        if (expuplineItem) {
            lineItems = expuplineItem;
        }
        else if (isAccessory) {
            lineItems = accessoryLineItem;
            editUrl = accessoryLineItem.pscEditUrl;
        }
        else {
            Object.values(losg.lineItems).forEach(function (lineData) {
                var _a;
                if (((_a = lineData.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE') {
                    lineItems = lineData;
                }
            });
        }
        var editRemoveIconBox = wlsUtils.multiUpCheck() ?
            [styles.editRemoveIcon, styles.editRemoveIconBox, styles.editRemoveMixcartIconBox].join(' ') :
            [styles.editRemoveIcon, styles.editRemoveIconBox].join(' ');
        if (lineItems) {
            if (isAccessory) {
                removeInfo = {
                    lineItem: (lineItems.itemType && lineItems.itemType.toUpperCase() === 'ACCESSORY') ? lineItems : {},
                    losgInfo: losg,
                    qualifierPlanName: qualifierPlanName || '',
                    showEditAndRemove: (lineItems.itemType && lineItems.itemType.toUpperCase() === 'ACCESSORY') ? true : false,
                };
            }
            else {
                removeInfo = {
                    lineItem: (lineItems.itemType && lineItems.itemType.toUpperCase() === 'DEVICE') ? lineItems : {},
                    losgInfo: losg,
                    qualifierPlanName: qualifierPlanName || '',
                    showEditAndRemove: (lineItems.itemType && lineItems.itemType.toUpperCase() === 'DEVICE') ? true : false,
                };
            }
        }
        var showDeleteConfirmationMdl = ((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP' &&
            ((_b = lineItems === null || lineItems === void 0 ? void 0 : lineItems.itemType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'DEVICE' && wlsUtils.isUpsellDevice(this.cartData, losg === null || losg === void 0 ? void 0 : losg.id);
        var showFirstNetRemovalModal = (losgsCount > 1 && CartUtilFunctions_1.isFNIntentPresent(losg) &&
            !CartUtilFunctions_1.isFNItentPresentInOtherLosgs(losg));
        return (React.createElement(React.Fragment, null, this.props.options && !this.hideEditAndRemoveLink && !this.props.options.showBundlesTreatment &&
            removeInfo &&
            React.createElement("div", { className: editRemoveIconBox },
                React.createElement(EditAndRemove_1.default, { data: {}, options: { ariaLabelEdit: "Edit " + wlsUtils.hoverTextForEditAndRemoveIcon(losg, index),
                        ariaLabelRemove: "Remove " + wlsUtils.hoverTextForEditAndRemoveIcon(losg, index), isFNLine: showFirstNetRemovalModal, isIconsMode: true,
                        showDeleteConfirmationModal: showDeleteConfirmationMdl }, events: {
                        onItemEdit: function () { _this.editLineForPscCustomers(editUrl); },
                        onItemRemove: function () {
                            _this.removeLineForPscCustomers(removeInfo.losgInfo.id || '', removeInfo.lineItem, removeInfo.losgInfo, removeInfo.qualifierPlanName, losgsCount, isAccessory);
                        },
                    } }))));
    };
    WirelessHelper.prototype.changeAccessoryQuantity = function (key, losgId, lineItem, losgType, losg) {
        var _this = this;
        var postRequest = CommonUtils.updateAccessoryQuantity(key, losg, lineItem, this.payload);
        this.reportingService.fireCartUpdateSubmitEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, key > 0 ? 'Update' : 'Delete', undefined, CartUtil.getLinkClickBasekUrl());
        this.props.events.doLoading(true);
        this.api.addToCart(postRequest).then(function (data) {
            _this.props.events.doLoading(false);
            if (data && data.content && data.content.payload) {
                _this.reportingService.fireCartUpdateSubmitEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', undefined, CartUtil.getLinkClickBasekUrl());
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
            }
            else {
                _this.reportingService.fireCartUpdateSubmitEvent(true, undefined, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', JSON.stringify(data), CartUtil.getLinkClickBasekUrl());
            }
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        }).catch(function (error) {
            _this.props.events.doLoading(false);
            _this.reportingService.fireCartUpdateSubmitEvent(false, error && error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', JSON.stringify(error), CartUtil.getLinkClickBasekUrl());
        });
    };
    WirelessHelper.prototype.incompleteCartMessage = function (losg) {
        var _this = this;
        var _a, _b;
        var isPlansFirstflow = !!(((_b = (_a = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _a === void 0 ? void 0 : _a.isPlanFirstLosg) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'true');
        return ((this.cartData.mixAndMatch || this.isCommonCart ||
            CartUtil.isNewWirelessPostpaidView()) && losg.requiredToCheckout &&
            Object.values(losg.requiredToCheckout).map(function (incompletePart, missingIndex) {
                var iconClasses = [_this.newWireless ? styles.errorMessageIcon :
                        '', icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartBadgealert, styles.redColorText];
                var linkClass = [_this.newWireless ? styles.missingErrorMessage :
                        styles.missingMessage, styles.redColorText];
                var messageToShow = '';
                if (incompletePart === 'WLS_PLAN') {
                    messageToShow = _this.cartSummaryCMSData.mixAndMatchPlanMissing;
                }
                else if (incompletePart === 'WLS_DEVICE') {
                    messageToShow = _this.cartSummaryCMSData.mixAndMatchDeviceMissing;
                }
                var postpaidLineItem = incompletePart === 'WLS_PLAN' ?
                    [styles.messageMargin, styles.postpaidLineItem, styles.displayFlex].join(' ') :
                    [styles.postpaidLineItem, styles.displayFlex].join(' ');
                var goBackLink = (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default(_this.props.testId, 'Link', 'Go back'), className: _this.newWireless ? styles.goBackLink : CartConfiguration_scss_1.commonLinkSmall, 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () {
                        if (incompletePart === 'WLS_PLAN' && !_this.isCommonCart) {
                            _this.editLineForPscCustomers(losg.pscEditUrl);
                        }
                        else if (incompletePart === 'WLS_PLAN' && _this.isCommonCart) {
                            _this.editLineForPscCustomers(losg.editUrl);
                        }
                        else if (incompletePart === 'WLS_DEVICE') {
                            window.location.href = '/buy/phones/';
                        }
                    } }, _this.cartSummaryCMSData.mixAndMatchGoBack));
                var isPlansFirstmessageRender = (React.createElement("div", { className: postpaidLineItem, key: "Missing " + missingIndex },
                    React.createElement("p", { className: styles.plansFirstWrapper },
                        React.createElement("span", { className: styles.buttonWrapper },
                            React.createElement(components_1.Button, { kind: "primaryBlue", 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () {
                                    _this.reportingService.fireLinkClickWithOutPageLoad(_this.cartSummaryCMSData.chooseDevice, '/buy/phones/');
                                    window.location.href = '/buy/phones/';
                                }, overrideLink: true }, _this.cartSummaryCMSData.chooseDevice || 'Choose a new device ')),
                        React.createElement("span", { className: styles.buttonWrapper },
                            React.createElement(components_1.Button, { kind: "secondary", 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () {
                                    _this.reportingService.fireLinkClickWithOutPageLoad(_this.cartSummaryCMSData.bringYourDevice, '/buy/phones/universal-sim-card-bring-your-own-phone.html');
                                    window.location.href = '/buy/phones/universal-sim-card-bring-your-own-phone.html';
                                }, overrideLink: true }, _this.cartSummaryCMSData.bringYourDevice || 'Bring your own device')))));
                var messageRender = (React.createElement("div", { className: _this.newWireless ? postpaidLineItem : styles.missingMessageDiv, key: "Missing " + missingIndex },
                    React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": "add a line" }),
                    !_this.newWireless && React.createElement("span", { className: linkClass.join(' ') }, messageToShow),
                    !_this.newWireless && goBackLink,
                    _this.newWireless && React.createElement("span", { className: linkClass.join(' ') },
                        messageToShow,
                        goBackLink)));
                return isPlansFirstflow && incompletePart === 'WLS_DEVICE' ?
                    isPlansFirstmessageRender : messageToShow ? messageRender : null;
            }));
    };
    WirelessHelper.prototype.accessoryModal = function (lineItem, losg, hideLink, isRTIMessageDisabled) {
        var _this = this;
        return (React.createElement(React.Fragment, null, lineItem.itemType.toUpperCase() === 'ACCESSORY' &&
            React.createElement("span", { className: styles.itemName },
                Utils.getLineItemName(lineItem, hideLink, this.isCommonCart, this.isExpressUp(), this.cartSummaryCMSData, this.cartData, this.isUnauthAccess),
                !hideLink && this.isExpressUp() && React.createElement("br", null),
                !hideLink &&
                    React.createElement(PostpaidAccessoryModal_1.default, { data: {
                            elementId: lineItem.id + '_Accessory',
                            linkText: "Qty : " + lineItem.quantity,
                            modalData: ['1', '2', '3', '4', 'Delete'],
                            selected: lineItem.quantity,
                        }, events: {
                            selectionChange: function (e) { return _this.changeAccessoryQuantity(e, losg.id, lineItem, losg.losgType, losg); },
                        } }),
                hideLink && !this.isUnauthAccess && React.createElement("span", null,
                    " - Qty: ",
                    lineItem.quantity),
                !this.isUnauthAccess &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.expupDeliveryDate }, wirelessRTI.displayEstDeliveryDate(lineItem, this.cartSummaryCMSData.expupEstDateLabel)),
                        !isRTIMessageDisabled && wlsUtils.isCommonDeliveryMethodAvailable(this.payload) &&
                            wirelessRTI.displayInventoryNotification(lineItem)))));
    };
    WirelessHelper.prototype.removeLineForPscCustomers = function (losgId, lineItem, losg, qualifierPlanName, losgsCount, isAccessory) {
        var _this = this;
        var _a;
        var linkNamelabel = isAccessory ? 'Remove accessory' : 'Remove line';
        this.reportingService.fireLinkClickWithOutPageLoad(linkNamelabel, ReportingService_1.PageUrls.CART_PAGE);
        var paymentType = this.cartMetaData && this.cartMetaData.paymentType ? this.cartMetaData.paymentType : '';
        var removeCartData = this.identifyPreapidCart() ? wlsUtils.buildRemovePrepaidCartData(losgId, lineItem, this.cartData._cartCreationSource, paymentType) :
            this.buildRemoveCartData(losgId, lineItem, losg, qualifierPlanName, isAccessory);
        var accessoryInLosg = Utils.IsAccessoryInLosg(losg) && !isAccessory;
        if (!isAccessory && losgsCount === 1 && !accessoryInLosg) {
            this.onRemoveClick();
        }
        else {
            var isWirelessExists = !!((_a = Utils.getCartResp()) === null || _a === void 0 ? void 0 : _a.wirelessCart);
            var removeActionLabel_1 = isAccessory ? 'Remove accessories' :
                this.cartSummaryCMSData.removeItemsLinkLabel;
            this.reportingService.reportSystemEventForSelectedAction(false, '-2', removeActionLabel_1, isWirelessExists ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT
                : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
            this.props.events.doLoading(true);
            this.api.addToCart(removeCartData).then(function (data) {
                _this.props.events.doLoading(false);
                if (data && data.content && data.content.payload) {
                    var isWirelessCartExists = !!(data.content.payload.wirelessCart &&
                        data.content.payload.wirelessCart.losgs);
                    _this.reportingService.reportSystemEventForSelectedAction(false, '0', removeActionLabel_1, isWirelessCartExists ?
                        ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                }
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }).catch(function (error) {
                _this.props.events.doLoading(false);
                _this.reportingService.reportSystemEventForSelectedAction(true, undefined, _this.cartSummaryCMSData.removeItemsLinkLabel, ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, 'Error in remvoing cart: ' + JSON.stringify(error));
            });
        }
    };
    WirelessHelper.prototype.filterLosgs = function (losg) {
        if (losg && losg.losgType && (losg.losgType.toUpperCase() === 'CHANGE'
            || losg.losgType.toUpperCase() === 'PRICE_CHANGE' || (this.externalOrderSourceType && !losg.displayLine))) {
            return false;
        }
        return true;
    };
    WirelessHelper.prototype.closeMonthlySavingModal = function () {
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ showMonthlySavings: false });
    };
    // Returns a fully styled Image container with SVG or Bitmap (PNG, JPEG, TIFF, GIF etc.) image
    WirelessHelper.prototype.getDeviceImgContainer = function (deviceImgInfo, bitmapImgStyle, svgImgStyle) {
        var _a;
        // TODO: Need to revisit this logic as this can be risky in future if there are any other SVG images being used
        var isSvgImg = ((_a = deviceImgInfo === null || deviceImgInfo === void 0 ? void 0 : deviceImgInfo.imageUrl) === null || _a === void 0 ? void 0 : _a.startsWith('<svg')) ? true : false;
        return (React.createElement(React.Fragment, null,
            isSvgImg && (React.createElement(components_1.IconSvg, { className: svgImgStyle, size: 32, svgNodeStr: deviceImgInfo.imageUrl })),
            !isSvgImg &&
                (React.createElement("div", { className: bitmapImgStyle },
                    React.createElement("img", { src: deviceImgInfo.imageUrl, alt: deviceImgInfo.imgAltText })))));
    };
    WirelessHelper.prototype.showPlanInfoAtLine = function (lineItem, mnmPlanDetails, lineIndex, subscriber, isSignatureFlagEnabled) {
        var _this = this;
        var _a;
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, this.cartData.mixAndMatch, true);
        lineItemPriceData.lineItemPrice.price = parseFloat("" + lineItemPriceData.lineItemPrice.price);
        var isSignatureDiscountPresent = false;
        var promoRef = (_a = mnmPlanDetails === null || mnmPlanDetails === void 0 ? void 0 : mnmPlanDetails.MnM) === null || _a === void 0 ? void 0 : _a.mnmPromotionReferences;
        var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
        if (promoRef) {
            promoRef.forEach(function (promoReference, promoIndex) {
                var _a;
                var promotion = _this.cartData.promotions
                    .find(function (promo) { return promo.id === promoReference; });
                if (promotion && (promotion.promotionCategory === 'iruPlanDiscount' ||
                    ((_a = promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual')) {
                    isSignatureDiscountPresent = true;
                }
            });
        }
        var isSignatureIconApplicable = isSignatureFlagEnabled && isSignatureDiscountPresent &&
            !CartUtilFunctions_1.isFNIntentPresent() && !CartUtil.isFNUserWithConsumerLine();
        return (React.createElement("div", { className: [styles.lineItems,
                styles.activationLineItem,
                !this.newWireless ? styles.lineItemContainer : '',
                this.newWireless ? styles.postpaidLineItem : ''].join(' ') },
            React.createElement("div", { className: [styles.lineItemName,
                    isSignatureIconApplicable ? styles.signatureFlex : ''].join(' ') },
                isSignatureIconApplicable && !CartUtil.isSMBCustomer() && !CartUtilFunctions_1.isFNIntentPresent() &&
                    !CartUtil.isFNUserWithConsumerLine() &&
                    React.createElement("span", { className: [styles.signatureIconWidth, styles.iconBookmark32].join(' ') }, (CartUtil.isAppreciationOfferPresent()) ?
                        React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                React.createElement("div", { className: isSignatureIconApplicable ? styles.signatureDiv : '' },
                    React.createElement(ui_components_1.Label, { data: {
                            isDecodingRequired: false,
                            text: lineItem.displayName,
                        }, options: { className: styles.itemName } }),
                    mnmPlanDetails &&
                        mnmPlanDetails.MnM &&
                        mnmPlanDetails.MnM.mnmPromotionReferences &&
                        mnmPlanDetails.MnM.mnmPromotionReferences.length > 0 &&
                        React.createElement(React.Fragment, null,
                            React.createElement("span", { className: styles.legalLinkSpace }),
                            React.createElement(TextTooltip_1.default, { data: {
                                    linkText: 'See discounts',
                                }, events: { doLoading: this.props.events.doLoading }, options: {
                                    isSignatureFlagEnabled: isSignatureFlagEnabled,
                                    losgId: lineIndex === null || lineIndex === void 0 ? void 0 : lineIndex.toString(), mnmPlanDetails: mnmPlanDetails,
                                    promotions: this.cartData.promotions,
                                    subscriber: subscriber,
                                } })))),
            lineItem.price && lineItemPriceData &&
                lineItemPriceData.lineItemPrice &&
                lineItemPriceData.lineItemPrice.price > 0 &&
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem"), data: lineItemPriceData.lineItemPrice, options: {
                        className: styles.lineItem,
                        decimalPoints: 2,
                        type: pricingType,
                    } })));
    };
    WirelessHelper.prototype.showSavingRewardModal = function (openModal) {
        this.setState({ showRewardModal: openModal });
    };
    WirelessHelper.prototype.isExpressUp = function () {
        if (this.props.options && this.props.options.isExpressUpgradeView) {
            return this.props.options.isExpressUpgradeView;
        }
        else {
            return false;
        }
    };
    WirelessHelper.prototype.expUpShowHideLink = function () {
        var _this = this;
        var expUpIsExpand = this.props.options && this.props.options.isExpandView;
        var linkText = expUpIsExpand ? this.cartSummaryCMSData.expupHideDetailsLabel :
            this.cartSummaryCMSData.expupSeeDetailsLabel;
        return (React.createElement("h3", { className: expUpStyle.seedetailsLinkB },
            React.createElement(components_1.Link, { kind: "withAppendIcon", testId: utils_1.default('Cart', 'See', 'Details'), "aria-label": "expUpShowHideLink", 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () { _this.expUpSeeDetails(); }, className: CartConfiguration_scss_1.commonLinkSmall, icon: expUpIsExpand ?
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }) :
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.DOWN }) }, linkText)));
    };
    WirelessHelper.prototype.showRetailPrice = function (lineItem, onlyRetailPrice) {
        var retailMessage = this.cartSummaryCMSData.retailPriceLabel || 'Retail price: ';
        if (this.downPaymentInfo.isDownPayment && lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE' && lineItem.contractDetails.contractType &&
            lineItem.contractDetails.contractType === 'NOCOMMIT' && !this.eapFlowContext.isEAPFlow && !this.isExpressUp()) {
            var retailPrice = lineItem.contractDetails.totalSalePrice;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.retailPrice },
                    retailMessage,
                    retailPrice && Utils.amountWithDecimal(retailPrice, 2, '$'))));
        }
        else if (this.downPaymentInfo.isDownPayment && lineItem && lineItem.itemType &&
            lineItem.itemType.toUpperCase() === 'DEVICE' && lineItem.contractDetails &&
            lineItem.contractDetails.totalSalePrice) {
            var retailPrice = lineItem.contractDetails.totalSalePrice;
            var downPaymentAmount = lineItem.contractDetails && lineItem.contractDetails.downPayment || 0;
            return (React.createElement(React.Fragment, null,
                !this.isExpressUp() &&
                    React.createElement("div", { className: styles.retailPrice },
                        retailMessage,
                        Utils.amountWithDecimal(retailPrice, 2, '$')),
                !onlyRetailPrice && downPaymentAmount > 0 &&
                    React.createElement("div", { className: [styles.lineItems, styles.postpaidLineItem].join(' ') },
                        React.createElement("span", { className: styles.itemName }, this.cartSummaryCMSData.downPaymentLabel),
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Item', 'Price'), data: { price: downPaymentAmount }, options: { className: styles.lineItem, decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL } }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessHelper.prototype.installmentMessage = function (monthlyPayments, effectiveDevicePrice, isPromoLineItem, isPromoDetails, lineItem, promoDiscountAmount) {
        var isSMBCustomer = CartUtil.isSMBCustomer();
        if (this.isUnauthAccess) {
            return '';
        }
        var contractDisplayName = (lineItem.contractDetails && lineItem.contractDetails.contractDisplayName) ?
            (lineItem.contractDetails.contractDisplayName).toLowerCase() : '';
        if (isSMBCustomer && lineItem.contractDetails && contractDisplayName &&
            contractDisplayName.indexOf('2 year') > -1) {
            var contractContent = this.cartSummaryCMSData.twoYearContract;
            return contractContent ? contractContent : '';
        }
        else if (effectiveDevicePrice && effectiveDevicePrice < 0) {
            var message = '';
            if (this.downPaymentInfo.isDownPayment && lineItem.contractDetails &&
                lineItem.contractDetails.downPayment && this.isDownPaymentSeePricingDetails) {
                var downPayment = lineItem.contractDetails.downPayment;
                var billCredit = lineItem.contractDetails.installmentAmount - effectiveDevicePrice;
                message = this.cartSummaryCMSData.billCreditNegativeAmountAprLabel ||
                    'Price for {0} mos. at 0% APR after {1} down payment & {2}/mo. bill credit.';
                message = message.replace('{0}', String(monthlyPayments));
                message = message.replace('{1}', Utils.amountWithDecimal(downPayment, 2, '$'));
                message = message.replace('{2}', Utils.amountWithDecimal(billCredit, 2, '$'));
                var linkLabel = this.cartSummaryCMSData.billCreditNegativeAmountLink || 'See pricing details';
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", null, message),
                    React.createElement("span", null,
                        React.createElement(TextTooltip_1.default, { data: { linkText: linkLabel }, events: { doLoading: this.props.events.doLoading }, options: {} }, this.getDownPaymentSeeDetails(lineItem, monthlyPayments)))));
            }
            else {
                message = this.cartSummaryCMSData.billCreditLabel.replace('{0}', String(monthlyPayments));
                return message;
            }
        }
        else {
            if (isPromoDetails || isPromoLineItem) {
                var amount = promoDiscountAmount || lineItem.contractDetails.installmentAmount - effectiveDevicePrice;
                if (this.downPaymentInfo.isDownPayment && lineItem.contractDetails &&
                    lineItem.contractDetails.downPayment) {
                    var message = this.cartSummaryCMSData.downPaymentAndBillCreditLabel ||
                        'Price for {0} mos. at 0% APR after {1} down payment & {2}/mo. bill credit';
                    message = message.replace('{0}', String(monthlyPayments))
                        .replace('{1}', Utils.amountWithDecimal(lineItem.contractDetails.downPayment, 2, '$'))
                        .replace('{2}', Utils.amountWithDecimal(amount, 2, '$'));
                    return message;
                }
                else {
                    var message = this.cartSummaryCMSData.billCreditPositiveAmountAprLabel ||
                        'Price for {0} mos. at 0% APR after {1}/mo. bill credit';
                    message = message.replace('{0}', String(monthlyPayments))
                        .replace('{1}', Utils.amountWithDecimal(amount, 2, '$'));
                    return message;
                }
            }
            else {
                if (this.downPaymentInfo.isDownPayment && lineItem.contractDetails &&
                    lineItem.contractDetails.downPayment) {
                    var message = this.cartSummaryCMSData.downPaymentOnlyLable ||
                        'Price for {0} mos. at 0% APR after {1} down payment';
                    message = message.replace('{0}', String(monthlyPayments))
                        .replace('{1}', String(lineItem.contractDetails.downPayment));
                    return message;
                }
                else {
                    var message = this.cartSummaryCMSData.noDownPaymentAndBillCreditLabel || 'Price for {0} mos. at 0% APR';
                    message = message.replace('{0}', String(monthlyPayments));
                    return message;
                }
            }
        }
    };
    WirelessHelper.prototype.getDownPaymentSeeDetails = function (lineItemInfo, monthlyPayments) {
        if (lineItemInfo) {
            var deviceInfo = wlsUtils.getDeviceMakeModel(lineItemInfo);
            var effectivePromoPricing = wlsUtils.getEffectivePromoPricing(lineItemInfo);
            var totalMonthlyPrice = Math.abs(effectivePromoPricing.effectiveDevicePrice);
            var deviceName = "" + deviceInfo.make + deviceInfo.model;
            var downpaymentInfo = {
                amount: lineItemInfo.contractDetails.downPayment,
                content: this.cartSummaryCMSData.downPaymentLabel,
            };
            var appliedPromotionsInfo = { amount: 0, content: '' };
            var remainingBalance = 0;
            if (lineItemInfo.downPaymentNegativePricing && lineItemInfo.downPaymentNegativePricing.appliedPromotions) {
                appliedPromotionsInfo.amount = lineItemInfo.downPaymentNegativePricing.promoAmount || 0;
                remainingBalance = lineItemInfo.downPaymentNegativePricing.remainingBalance || 0;
                var appliedPromotions = lineItemInfo.downPaymentNegativePricing.appliedPromotions;
                switch (appliedPromotions) {
                    case 'HYLA_TRADEIN_OFFER':
                        appliedPromotionsInfo.content = this.cartSummaryCMSData.hylaTradeinOfferLabel;
                        break;
                    case 'HYLA_TRADEIN_PORTIN_OFFER':
                        appliedPromotionsInfo.content = this.cartSummaryCMSData.hylaTradeinPortinOfferLabel;
                        break;
                    case 'HYLA_TRADEIN_BOGO_OFFER':
                        appliedPromotionsInfo.content = this.cartSummaryCMSData.hylaTradeinBogoOfferLabel;
                        break;
                    case 'HYLA_TRADEIN_PORTIN_BOGO_OFFER':
                        appliedPromotionsInfo.content = this.cartSummaryCMSData.hylaTradeinPortinBogoOfferLabel;
                        break;
                    case 'BOGO_OFFER':
                        appliedPromotionsInfo.content = this.cartSummaryCMSData.bogoOfferLabel;
                        break;
                    default:
                        appliedPromotionsInfo.content = '';
                }
            }
            var headingText = this.cartSummaryCMSData.yourDeviceLabel || "Your {0} pricing ";
            headingText = headingText.replace('{0}', deviceName);
            var yourDeviceRetailLabel = this.cartSummaryCMSData.yourDeviceRetailLabel || '{0}  (retail price)';
            yourDeviceRetailLabel = yourDeviceRetailLabel.replace('{0}', deviceName);
            var totalMonthlySubLabel = this.cartSummaryCMSData.totalMonthlySubLabel ||
                'Your remaining balance will be applied as a {0}/mo. credit over {1} months.';
            totalMonthlySubLabel = totalMonthlySubLabel.replace('{0}', String(totalMonthlyPrice));
            totalMonthlySubLabel = totalMonthlySubLabel.replace('{1}', String(monthlyPayments));
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: textTooptipStyles.lineHeading },
                    " ",
                    headingText,
                    " "),
                React.createElement("div", null,
                    React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: this.cartSummaryCMSData.yourDeviceSubLabel }, options: { className: textTooptipStyles.lineSubtext } })),
                React.createElement("div", { className: textTooptipStyles.planItem },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: yourDeviceRetailLabel }, options: { className: textTooptipStyles.lineItemName } })),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'Plan', 'Price'), data: { price: lineItemInfo.contractDetails.totalSalePrice }, options: { className: textTooptipStyles.lineItemPrice,
                                decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL,
                            } }))),
                downpaymentInfo.amount && downpaymentInfo.amount !== 0 &&
                    React.createElement("div", { className: textTooptipStyles.planItem },
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: downpaymentInfo.content }, options: { className: textTooptipStyles.lineItemName } })),
                        React.createElement("div", null,
                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'downpaymentInfo', 'Price'), data: { price: downpaymentInfo.amount }, options: { className: textTooptipStyles.lineItemPrice,
                                    decimalPoints: 2, isDataPriceNegative: true, type: PriceContainerProps_1.PricingType.XSMALL,
                                } }))),
                appliedPromotionsInfo.amount && appliedPromotionsInfo.amount !== 0 &&
                    React.createElement("div", { className: textTooptipStyles.planItem },
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: appliedPromotionsInfo.content }, options: { className: textTooptipStyles.lineItemName } })),
                        React.createElement("div", null,
                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'appliedPromotionsInfo', 'Price'), data: { price: appliedPromotionsInfo.amount }, options: { className: textTooptipStyles.lineItemPrice,
                                    decimalPoints: 2, isDataPriceNegative: true, type: PriceContainerProps_1.PricingType.XSMALL,
                                } }))),
                remainingBalance && remainingBalance !== 0 &&
                    React.createElement("div", { className: textTooptipStyles.planItem },
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: this.cartSummaryCMSData.remainingBalanceLabel }, options: { className: textTooptipStyles.lineItemName } })),
                        React.createElement("div", null,
                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'remainingBalance', 'Price'), data: { price: remainingBalance, billingNote: 'CR' }, options: { className: textTooptipStyles.lineItemPrice,
                                    decimalPoints: 2, isDataPriceNegative: false, type: PriceContainerProps_1.PricingType.XSMALL,
                                } }))),
                effectivePromoPricing && effectivePromoPricing.effectiveDevicePrice !== 0 &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: textTooptipStyles.solidLine }),
                        React.createElement("div", { className: [textTooptipStyles.planItem, textTooptipStyles.m10top].join(' ') },
                            React.createElement("div", null,
                                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: this.cartSummaryCMSData.totalMonthlyLabel }, options: { className: textTooptipStyles.lineItemNamebold } })),
                            React.createElement("div", null,
                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'TotalMonthlyPrice', 'Price'), data: { price: totalMonthlyPrice, billingNote: '/mo.' }, options: { className: textTooptipStyles.lineItemPrice,
                                        decimalPoints: 2, isDataPriceNegative: true, type: PriceContainerProps_1.PricingType.XSMALL,
                                    } }))),
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: totalMonthlySubLabel }, options: { className: textTooptipStyles.smallText } })))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessHelper.prototype.lobHideEditAndRemoveLink = function () {
        if (this.hideEditAndRemoveLink || (this.cartData._cartCreationSource === 'PSC')
            || this.isCommonCart) {
            return true;
        }
        else {
            return false;
        }
    };
    WirelessHelper.prototype.displayAccessoryLineItem = function (losg, lineItem) {
        var _a;
        var accessoryInfo = this.accessoryModal(lineItem, losg, this.isUnauthAccess);
        return (React.createElement("div", { className: styles.lineItems },
            React.createElement("span", { className: [styles.expupItemname, styles.lineItemName].join(' ') }, accessoryInfo),
            !this.isUnauthAccess && (losg.losgType.toUpperCase() === 'UP' || losg.losgType.toUpperCase() === 'AL'
                || losg.losgType.toUpperCase() === 'ACC') &&
                React.createElement("div", { className: styles.expupItemname },
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Accessory', 'Info_Price'), data: { price: ((_a = lineItem.price) === null || _a === void 0 ? void 0 : _a.total) || 0 }, options: {
                            className: styles.crpPrice, decimalPoints: 2,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL,
                        } }))));
    };
    WirelessHelper.prototype.displayChangeRatePlanLineItem = function () {
        return (React.createElement("div", { className: styles.crpContainer },
            React.createElement("div", { className: styles.crpContent },
                React.createElement("span", { className: styles.crpChangeLabel }, "Changed"),
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Changed', 'RatePlan'), data: { isDecodingRequired: false, text: wlsUtils.ischangeRatePlanFlow().crpPlanName } })),
            !this.isUnauthAccess &&
                React.createElement("div", null,
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Wireless', 'Changed', 'RatePlan_Price'), data: { billingNote: '/mo.', price: wlsUtils.ischangeRatePlanFlow().crpPrice }, options: { className: styles.crpPrice, decimalPoints: 2, overrideAccessibility: true,
                            type: PriceContainerProps_1.PricingType.XSMALL } }))));
    };
    WirelessHelper.prototype.displayCrpLegalContent = function () {
        var _a, _b;
        return (React.createElement("section", null,
            React.createElement(components_1.Alert, { closeable: false, onWhite: true, type: "info", className: styles.showCrpLegalMsg },
                React.createElement("div", { "data-test-id": "Show Legal Message header for CRP", className: styles.crpLegalMsg1, dangerouslySetInnerHTML: { __html: (_a = this.cartSummaryCMSData) === null || _a === void 0 ? void 0 : _a.crpLegalMsgHeader.replace('{0}', wlsUtils.ischangeRatePlanFlow().crpPlanStartdate) } }),
                React.createElement("div", { "data-test-id": "Show Legal Message for CRP", className: styles.crpLegalMsg2, dangerouslySetInnerHTML: { __html: (_b = this.cartSummaryCMSData) === null || _b === void 0 ? void 0 : _b.crpLegalMsgContent } }))));
    };
    WirelessHelper.prototype.getProductSPODetails = function (lineItem, losg, subscriberNUmber) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var isLoggedIn, customerId, spoData, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        isLoggedIn = Utils.isLoginRequiredonCart();
                        customerId = this.isCommonCart && ((_c = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.commonCart) === null || _b === void 0 ? void 0 : _b.account) === null || _c === void 0 ? void 0 : _c.customerId);
                        if (!!isLoggedIn) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        this.spoDataAvailSkus.push(lineItem.productSKU);
                        return [4 /*yield*/, this.api.getSpoData(lineItem, 'cart', losg, subscriberNUmber, customerId, wlsUtils.getZipCode('attPersistantLocalization'))];
                    case 2:
                        spoData = _d.sent();
                        this.state.productDetails[lineItem.productSKU] = spoData;
                        this.setState({ productDetails: this.state.productDetails });
                        this.getInsuranceData(lineItem);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        this.spoDataAvailSkus.splice(this.spoDataAvailSkus.indexOf(lineItem.productSKU), 1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WirelessHelper.prototype.getInsuranceData = function (lineItem) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var insuranceFeatures, itemsList, insuranceItems, applicableFeatures;
            return __generator(this, function (_g) {
                insuranceFeatures = (_b = (_a = this.state.productDetails[lineItem.productSKU].content) === null || _a === void 0 ? void 0 : _a.wireless) === null || _b === void 0 ? void 0 : _b.features;
                itemsList = (_d = (_c = this.state.productDetails[lineItem.productSKU].content) === null || _c === void 0 ? void 0 : _c.wireless) === null || _d === void 0 ? void 0 : _d.itemList;
                insuranceItems = [];
                applicableFeatures = (_e = itemsList === null || itemsList === void 0 ? void 0 : itemsList.find(function (item) { return item.productSKU === (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productSKU); })) === null || _e === void 0 ? void 0 : _e.applicableFeatures;
                if (insuranceFeatures && applicableFeatures) {
                    (_f = Object.keys(insuranceFeatures)) === null || _f === void 0 ? void 0 : _f.forEach(function (productId) {
                        if (applicableFeatures === null || applicableFeatures === void 0 ? void 0 : applicableFeatures.includes(productId)) {
                            var insuranceItem = insuranceFeatures[productId];
                            if (insuranceItem) {
                                insuranceItems.push(insuranceItem);
                            }
                        }
                    });
                }
                if (insuranceItems && (insuranceItems === null || insuranceItems === void 0 ? void 0 : insuranceItems.length) > 0) {
                    this.setState({ insuranceItems: insuranceItems });
                }
                return [2 /*return*/];
            });
        });
    };
    WirelessHelper.prototype.renderInsurance = function (losg, lineItem, isMDPPInsurance) {
        return (React.createElement("div", null,
            React.createElement(WirelessInsurance_1.default, { deviceLineItem: lineItem, lineItems: losg.lineItems, insuranceItems: this.state.insuranceItems, losg: losg, cartCreationSource: this.cartData._cartCreationSource, events: this.props.events, isMDPPInsurancePresent: isMDPPInsurance })));
    };
    WirelessHelper.prototype.buildRemoveCartData = function (losgId, lineItem, losg, qualifierPlanName, isAccessory) {
        var _a;
        var alParam = wlsUtils.buildLineItemExtraParam(this.payload, losgId);
        var removeItemtype = CartUtil.getPostpaidflowtype() !== 'UP' ? CartActions_1.ItemType.DEVICE : CartActions_1.ItemType.LOSG;
        var splitAccessory = (isAccessory && ((_a = Utils.getCartResp()) === null || _a === void 0 ? void 0 : _a.enableSplitAccessoryLine) === true) ? true : false;
        var correctLosgId = (splitAccessory) ? ((lineItem === null || lineItem === void 0 ? void 0 : lineItem._parentLosgId) ? lineItem._parentLosgId : losgId) : losgId;
        var removeCartRequest = {
            itemsList: [
                {
                    accountId: alParam.accountId,
                    action: CartActions_1.ActionType.REMOVE,
                    extraData: {
                        invocationSource: 'cart',
                    },
                    itemId: lineItem.id,
                    itemType: (isAccessory) ? CartActions_1.ItemType.ACCESSORY : removeItemtype,
                    losgId: correctLosgId,
                    losgType: losg.losgType,
                    primaryPlanSubscriber: alParam.primaryPlanSubscriber,
                    productGroup: CartActions_1.ProductGroupType.WIRELESS,
                    productRootId: alParam.productRootId,
                    productSKU: (this.isCommonCart || isAccessory) ? lineItem.productSKU : undefined,
                    quantity: 1,
                },
            ],
            serviceContext: {
                srcSystem: 'IDSE',
            },
            shoppingContext: wlsUtils.buildShoppingContext(this.payload, losg.losgType),
        };
        return removeCartRequest;
    };
    WirelessHelper.prototype.identifyPreapidCart = function () {
        return this.cartMetaData && this.cartMetaData.paymentType &&
            this.cartMetaData.paymentType === CartViewPanelProps_1.PlanType.WIRELESS_PREPAID;
    };
    WirelessHelper.prototype.showAddALineComponent = function (losg, CMSData) {
        var isPsc = this.cartData && this.cartData._cartCreationSource === 'PSC';
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.expupDivider }),
            React.createElement("div", null,
                React.createElement(AddALine_1.default, { data: { losg: losg, isPsc: isPsc, CMSData: CMSData }, events: this.props.events }))));
    };
    WirelessHelper.prototype.showABPComponent = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var autoPaySelectedValue = ((_c = (_b = (_a = this.payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.autoPaySelected) ? 1 : 0;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.expupDivider }),
            React.createElement("div", null,
                React.createElement(AutoBillPay_1.default, { key: autoPaySelectedValue, autoPayAmount: (_f = (_e = (_d = this.payload.metadata) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.wirelessMetadata) === null || _f === void 0 ? void 0 : _f.abpPromotionAmount, autoPaySelected: (_j = (_h = (_g = this.payload.metadata) === null || _g === void 0 ? void 0 : _g.metadata) === null || _h === void 0 ? void 0 : _h.wirelessMetadata) === null || _j === void 0 ? void 0 : _j.autoPaySelected, events: this.props.events }))));
    };
    WirelessHelper.prototype.getCRPMessageEligibility = function (losg) {
        var _a, _b, _c, _d;
        var deviceLineItem = wlsUtils.getDeviceLineItem(losg);
        var isCRPStandAlone = false;
        if (deviceLineItem && this.state.productDetails[deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU]) {
            var spoData = this.state.productDetails[deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU];
            var itemsList = (_b = (_a = spoData === null || spoData === void 0 ? void 0 : spoData.content) === null || _a === void 0 ? void 0 : _a.wireless) === null || _b === void 0 ? void 0 : _b.itemList;
            var priceDetails = (_c = itemsList === null || itemsList === void 0 ? void 0 : itemsList.find(function (item) { return item.productSKU === (deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU); })) === null || _c === void 0 ? void 0 : _c.price;
            var appliedPricing = priceDetails && priceDetails.length > 0 &&
                priceDetails.filter(function (item) {
                    var _a, _b;
                    return item.commitmentTermId === ((_b = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.contractDetails) === null || _a === void 0 ? void 0 : _a._commitmentTermId) === null || _b === void 0 ? void 0 : _b.toString());
                });
            var promoPricing = appliedPricing && appliedPricing.length > 0 && ((_d = appliedPricing[0]) === null || _d === void 0 ? void 0 : _d.promoPricing);
            var standalonePromo_1 = [];
            if (!lodash_1.isEmpty(promoPricing)) {
                promoPricing.forEach(function (promo) {
                    if (promo.promoType === 'standalone') {
                        standalonePromo_1.push(promo);
                    }
                });
            }
            if (standalonePromo_1.length > 0 && !wlsUtils.getStandAlonePromotion(losg)) {
                isCRPStandAlone = true;
            }
        }
        return isCRPStandAlone;
    };
    WirelessHelper.prototype.renderTradeInComponent = function (losg, lineItem, isExpressView) {
        var _a, _b, _c, _d;
        var tradeInStyle = isExpressView ? styles.expupTradein : '';
        var estimatedValueForNewFlow = this.newWireless ? (_a = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _a === void 0 ? void 0 : _a.hylaDiscountValue : '';
        var hylaTradeinPromotion = this.getTradeinPromotion(lineItem);
        var deviceTradeInAmount = this.getHylaDiscountDetails(losg, hylaTradeinPromotion);
        var hylaTradeinLineItem = wlsUtils.getHylaTradeInLineItem(losg);
        var deviceLineItem = wlsUtils.getDeviceLineItem(losg);
        if ((deviceTradeInAmount === null || deviceTradeInAmount === void 0 ? void 0 : deviceTradeInAmount.tradeInPromoAvailable) && !wlsUtils.isBYOD(losg) &&
            ((_c = (_b = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.hardGood) === null || _b === void 0 ? void 0 : _b.hardGoodType) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'DEVICE' &&
            !wlsUtils.isPayupLine(losg) &&
            (this.payload.enableDisplayCartTradeinComponent)) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.expupDivider }),
                React.createElement("div", { className: tradeInStyle },
                    React.createElement(WirelessTradeIn_1.default, { data: { cartCreationSource: this.cartData._cartCreationSource, deviceMSRP: (_d = lineItem.contractDetails) === null || _d === void 0 ? void 0 : _d.totalSalePrice,
                            estimatedValueForNewFlow: estimatedValueForNewFlow, hylaTradeinLineItem: hylaTradeinLineItem, hylaTradeinPromotion: hylaTradeinPromotion,
                            isRewardCard: deviceTradeInAmount === null || deviceTradeInAmount === void 0 ? void 0 : deviceTradeInAmount.isRewardCard, losg: losg, tradeinAmounts: deviceTradeInAmount }, events: this.props.events }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessHelper.prototype.getTradeinPromotion = function (lineItem) {
        var tradeinPromotions = this.cartData.promotions;
        var hylaTradeinPromotion;
        if (tradeinPromotions) {
            tradeinPromotions.forEach(function (promotion) {
                var _a;
                if (promotion.promotionCategory === 'HYLA_TRADEIN' && ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.promotionReferences) === null || _a === void 0 ? void 0 : _a.includes(promotion.id))) {
                    hylaTradeinPromotion = promotion;
                }
            });
        }
        return hylaTradeinPromotion;
    };
    WirelessHelper.prototype.getHylaDiscountDetails = function (losg, hylaTradeinPromotion) {
        var _a, _b, _c, _d, _e;
        var deviceLineItem = wlsUtils.getDeviceLineItem(losg);
        var withTradeinAmt = 0;
        var withoutTradeinAmt = 0;
        var maxDiscount = 0;
        var tradeinPromoAvailable = false;
        var isRewardCardPromo = false;
        if (deviceLineItem && this.state.productDetails[deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU]) {
            var spoData = this.state.productDetails[deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU];
            var itemsList = (_b = (_a = spoData === null || spoData === void 0 ? void 0 : spoData.content) === null || _a === void 0 ? void 0 : _a.wireless) === null || _b === void 0 ? void 0 : _b.itemList;
            var priceDetails = (_c = itemsList === null || itemsList === void 0 ? void 0 : itemsList.find(function (item) { return item.productSKU === (deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.productSKU); })) === null || _c === void 0 ? void 0 : _c.price;
            var appliedPricing = priceDetails && priceDetails.length > 0 &&
                priceDetails.filter(function (item) {
                    var _a, _b;
                    return item.commitmentTermId === ((_b = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.contractDetails) === null || _a === void 0 ? void 0 : _a._commitmentTermId) === null || _b === void 0 ? void 0 : _b.toString());
                });
            withoutTradeinAmt = appliedPricing && appliedPricing.length > 0 && ((_d = appliedPricing[0]) === null || _d === void 0 ? void 0 : _d.netPrice);
            var promoPricing = appliedPricing && appliedPricing.length > 0 && ((_e = appliedPricing[0]) === null || _e === void 0 ? void 0 : _e.promoPricing);
            var tradeInPromo_1 = [];
            var nonTradeInPromo_1 = [];
            if (!lodash_1.isEmpty(promoPricing)) {
                promoPricing.forEach(function (promo) {
                    if (promo.promoType !== 'tradein' && promo.promoType !== 'standalone') {
                        nonTradeInPromo_1.push(promo);
                        tradeinPromoAvailable = true;
                    }
                    else if (promo.promoType === 'tradein') {
                        tradeInPromo_1.push(promo);
                        tradeinPromoAvailable = true;
                    }
                });
            }
            if (!lodash_1.isEmpty(tradeInPromo_1)) {
                if (tradeInPromo_1.length > 1) {
                    if (hylaTradeinPromotion) {
                        var hylaPromo = tradeInPromo_1.filter(function (promoitem) { return promoitem.hylaOfferCode ===
                            hylaTradeinPromotion.promotionCode; });
                        maxDiscount = hylaPromo && hylaPromo.length > 0 && hylaPromo[0].tradeinDiscount;
                        withTradeinAmt = hylaPromo && hylaPromo.length > 0 && hylaPromo[0].monthlyPromoPrice;
                    }
                    else {
                        var promo = tradeInPromo_1.reduce(function (acc, current) {
                            return parseInt(current === null || current === void 0 ? void 0 : current.marketingPriority, 10) < parseInt(acc === null || acc === void 0 ? void 0 : acc.marketingPriority, 10)
                                ? current : acc;
                        }, tradeInPromo_1[0]);
                        maxDiscount = promo.tradeinDiscount;
                        withTradeinAmt = promo.monthlyPromoPrice;
                    }
                }
                else {
                    maxDiscount = !lodash_1.isEmpty(tradeInPromo_1) && tradeInPromo_1[0].tradeinDiscount;
                    withTradeinAmt = !lodash_1.isEmpty(tradeInPromo_1) && tradeInPromo_1[0].monthlyPromoPrice;
                }
            }
            else if (!lodash_1.isEmpty(nonTradeInPromo_1)) {
                maxDiscount = nonTradeInPromo_1[0].tradeinDiscount;
                withTradeinAmt = nonTradeInPromo_1[0].monthlyPromoPrice;
                withoutTradeinAmt = nonTradeInPromo_1[0].monthlyPromoPrice;
                isRewardCardPromo = true;
            }
        }
        var tradeinPromotionData = {
            isRewardCard: isRewardCardPromo,
            maxPromo: maxDiscount === null || maxDiscount === void 0 ? void 0 : maxDiscount.toString(),
            tradeInPromoAvailable: tradeinPromoAvailable,
            withTradeinAmt: withTradeinAmt,
            withoutTradeinAmt: withoutTradeinAmt,
        };
        return (tradeinPromotionData);
    };
    WirelessHelper.prototype.enableWirelessInsurance = function (losg) {
        var _a, _b;
        return this.cartData.cartStatus.cartState === 'COMPLETE'
            && !this.eapFlowContext.isEAPFlow && !wlsUtils.isBYOD(losg) &&
            !wlsUtils.isHotspot(losg) && (((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.insuranceItems) === null || _b === void 0 ? void 0 : _b.length) > 0);
    };
    WirelessHelper.prototype.getLegalContent = function (legalAEMUrl, legalContent) {
        var _this = this;
        if (legalAEMUrl) {
            CartUtil.getLegalIDPData(legalAEMUrl, legalContent, legalContent.longtext, legalContent.shorttext).then(function (response) {
                if (response.longtext) {
                    legalContent.longtext = response.longtext;
                    legalContent.showLegal = true;
                    _this.openBOGOSeeOfferModal();
                }
                _this.setState({ legalContenFound: true });
            }).catch(function (err) {
                legalContent.showLegal = false;
                _this.setState({ legalContenFound: false });
            });
        }
    };
    WirelessHelper.prototype.showDeviceInfo = function (deviceInfo, isByod, losg, lineItemPriceData, deviceDisplayName) {
        var isNewLblOrMultiUp = wlsUtils.newLabelCheck() || wlsUtils.multiUpCheck();
        return (React.createElement("section", null,
            React.createElement("div", { className: styles.deviceInfoContainer },
                React.createElement("article", { className: styles.deviceInfo },
                    isNewLblOrMultiUp && React.createElement("span", { className: styles.crpChangeLabel }, " New "),
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('WRLS', 'Device', 'Info'), data: { isDecodingRequired: false, text: deviceInfo } })),
                deviceDisplayName && React.createElement("article", { className: styles.deviceDisplayName },
                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('WRLS', 'Device', 'Display_Name'), data: { isDecodingRequired: false, text: deviceDisplayName } }))),
            !this.isUnauthAccess && !isByod &&
                ((losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'UP' || (losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'AL') &&
                !(CartUtil.checkShareCartEligibilityForAndroid() || (Utils === null || Utils === void 0 ? void 0 : Utils.isAppleWatchFlow(losg))) &&
                React.createElement("article", null,
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Device', 'Info_Price_b'), data: { billingNote: '/mo.', price: lineItemPriceData }, options: {
                            className: styles.crpPrice, decimalPoints: 2,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL,
                        } }))));
    };
    WirelessHelper.prototype.showPlanInfo = function (losg) {
        var planInfo = Utils.getPlanInfo(losg);
        return (React.createElement("div", { className: styles.crpContainer },
            React.createElement("div", { className: styles.crpContentEsim },
                React.createElement(ui_components_1.RichText, { testId: utils_1.default('WRLS', 'Plan', 'Info'), data: { isDecodingRequired: false, text: planInfo === null || planInfo === void 0 ? void 0 : planInfo.displayName } })),
            !this.isUnauthAccess &&
                React.createElement("div", null,
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Info_Price'), data: { billingNote: '/mo.', price: planInfo === null || planInfo === void 0 ? void 0 : planInfo.price }, options: {
                            className: styles.crpPrice, decimalPoints: 2,
                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL,
                        } }))));
    };
    WirelessHelper.prototype.dueMonthlyCrpLaterMessage = function (losg, deviceLineItem) {
        var _a, _b, _c;
        var hylaTradeinPromotion = this.getTradeinPromotion(deviceLineItem);
        var deviceTradeInAmount = this.getHylaDiscountDetails(losg, hylaTradeinPromotion);
        var dueMonthlyCrpLaterMessageText = this.cartSummaryCMSData.dueMonthlyCrpLaterMessage.replace('(0)', (_a = deviceTradeInAmount === null || deviceTradeInAmount === void 0 ? void 0 : deviceTradeInAmount.withTradeinAmt) === null || _a === void 0 ? void 0 : _a.toString())
            .replace('(1)', (_b = deviceTradeInAmount.withoutTradeinAmt) === null || _b === void 0 ? void 0 : _b.toString());
        if (((_c = this.cartData) === null || _c === void 0 ? void 0 : _c.crpLater) && hylaTradeinPromotion && (hylaTradeinPromotion === null || hylaTradeinPromotion === void 0 ? void 0 : hylaTradeinPromotion.useForPriceCalculation) &&
            dueMonthlyCrpLaterMessageText) {
            return (React.createElement("div", { className: styles.dueMonthlyCrpLaterMessage },
                React.createElement(components_1.Alert, { closeable: false, className: styles.dueMonthlyCrpLaterAlertBox, type: "warning" },
                    React.createElement("div", { "data-test": "showAllPlansUpadatedWarningMsg", className: styles.dueMonthlyErrorMessage, dangerouslySetInnerHTML: { __html: dueMonthlyCrpLaterMessageText }, style: { fontSize: '14px !important' } }))));
        }
        return React.createElement(React.Fragment, null);
    };
    WirelessHelper.prototype.expUpSeeDetails = function (showExpandView) {
        this.props.events.onDeviceChange();
    };
    WirelessHelper.DISPLAY_SHIPPING_TYPES = ['EXPRESSSHIPPING', 'STANDARDSHIPPING', 'OVERNIGHT'];
    WirelessHelper.DISPLAY_CAPACITY_EDIT_OPTION_INCLUDES_WATCH = ['IPHONE_REFURBISHED', 'IPHONE', 'SMART_PHONE', 'TABLET', 'SMART_DEVICE', 'SMARTPHONE'];
    return WirelessHelper;
}(React.Component));
exports.default = WirelessHelper;
//# sourceMappingURL=WirelessHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessHelper.js
// module id = 2289
// module chunks = 8